import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IKeyField {
	changeKey: (value: string) => void;
}

const KeyField: React.FC<IKeyField> = ({ changeKey }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterKeyName') }], [t]);

	return (
		<FormInput
			testId="KeyField"
			name="key"
			label="keyNameLabel"
			onChange={changeKey}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(KeyField);
